<template>
    <div class="pt-0 pb-4 container-fluid">
        <div class="row" v-if="!isLoading">
            <div class="col-12">
                <BarcodeScanner ref="barCodeScanner" :onDetect="buscaProducto" />
            </div>
            <div class="input-group mt-3" style="height: 50px">
                <input type="text" class="form-control" placeholder="Buscar SKU" v-model="querySKU">
                <button class="btn btn-success m-0 bg-secondary" type="submit" @click="buscarSKU">Buscar</button>
            </div>
            <div class='container h-100 py-5'>
                <div class="row d-flex justify-content-center align-items-center h-100">
                    <div class="col-12" v-if="cart.length !== 0">
                        <div class="d-flex justify-content-between align-items-center mb-4">
                            <h3 class="fw-normal mb-0 text-black">Productos</h3>
                        </div>
                        <div class="card rounded-3 mb-4" v-for="(producto, index) in cart" :key="producto.id">
                            <div class="card-body p-4">
                                <div class="row d-flex justify-content-between align-items-center">
                                    <div class="col-md-3 col-lg-3 col-xl-3">
                                        <p class="lead fw-normal mb-2">{{ producto.nombre }}</p>
                                        <p><span class="text-muted">Talla: </span>{{ producto.talla ? producto.talla :
            '' }} <span class="text-muted">Color:
                                            </span>{{ producto.color ? producto.color : '' }}</p>
                                    </div>
                                    <div class="col-md-1 col-lg-1 col-xl-1">
                                        <p><span class="text-muted">Ultima compra:</span></p>
                                        <p><span class="text-muted">{{ producto.ultima_compra }}</span></p>
                                    </div>
                                    <div class="col-md-1 col-lg-1 col-xl-1">
                                        <p><span class="text-muted">Inventario actual:</span></p>
                                        <p><span class="text-muted">{{ producto.inventario }}</span></p>
                                    </div>
                                    <div class="col-md-1 col-lg-1 col-xl-1">
                                        <p><span class="text-muted">Compra Sugerida:</span></p>
                                        <p><span class="text-muted">{{ producto.sugerido_absoluto }}</span></p>
                                    </div>
                                    <div class="col-md-3 col-lg-3 col-xl-2">
                                        <p><span class="text-muted">Pre ordenar:</span></p>
                                        <div class="d-flex" v-if="producto.existencia > 0">
                                            <button data-mdb-button-init data-mdb-ripple-init
                                                class="btn btn-link px-2 mb-0"
                                                onclick="this.parentNode.querySelector('input[type=number]').stepDown()"
                                                @click="decrementPreOrden(producto)">
                                                <i class="fas fa-minus"></i>
                                            </button>

                                            <input min="1" :max="producto.existencia"
                                                v-model="producto.cantidad_sugerida" type="number"
                                                class="form-control form-control-sm"
                                                @input="handleInputChangePreOrden(producto, $event)" />

                                            <button data-mdb-button-init data-mdb-ripple-init
                                                class="btn btn-link px-2 mb-0"
                                                onclick="this.parentNode.querySelector('input[type=number]').stepUp()"
                                                @click="incrementPreOrden(producto)">
                                                <i class="fas fa-plus"></i>
                                            </button>
                                        </div>
                                        <div class="d-flex" v-else>
                                            <p><span class="text-muted">SIN STOCK DISPONIBLE</span></p>
                                        </div>
                                    </div>
                                    <div class="col-md-2 col-lg-2 col-xl-2">
                                        <p><span class="text-muted">Total:</span></p>
                                        <div class="d-flex">
                                            <h5 class="mb-0">${{ producto.total }}</h5>
                                        </div>
                                    </div>
                                    <div class="row text-end mt-3">
                                        <a class="text-danger" @click="eliminarProducto(index, producto)"><i
                                                class="fas fa-trash fa-lg"></i></a>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="card rounded-3">
                            <div class="card-body">
                                <div class="row d-flex">
                                    <div class=" d-flex col-6">
                                        <button type="button" data-mdb-button-init data-mdb-ripple-init
                                            class="btn btn-warning btn-block m-0 w-100 bg-primary"
                                            @click.="crearPreOrden()">Crear orden</button>
                                    </div>
                                    <div class="col-6 text-center">
                                        <p><span class="text-muted">Total:</span></p>
                                        <h5 class="mb-0">${{ totalPreOrden }}</h5>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import axios from 'axios'
import Swal from 'sweetalert2';
import { writeFileXLSX, utils } from "xlsx";
import BarcodeScanner from '../components/BarcodeScanner.vue';



const beforeUnloadHandler = (event) => {
    // Recommended
    event.preventDefault();

    // Included for legacy support, e.g. Chrome/Edge < 119
    event.returnValue = true;
};


export default {
    name: "scanner",
    components: {
        BarcodeScanner,
    },
    props: {
        clientId: {
            type: String,
            required: true // Esto asegura que el clienteId sea requerido
        },
        sucursalId: {
            type: String,
            required: true // Esto asegura que el clienteId sea requerido
        },
        clientName: {
            type: String,
            required: true
        },
        clientSucursal: {
            type: String,
            required: true
        }
    },
    data() {
        return {
            result: null,
            // id: null,
            isLoading: true,
            stocks: new Map(),
            productos: new Map(),
            cartAux: new Map(),
            cart: [],
            errURL: false,
            totalPreOrden: 0,
            endOperation: false,
            querySKU: "",
            inventario: 0,
            clientID: atob(this.clientId),
            sucursalID: atob(this.sucursalId),
            clientNAME: atob(this.clientName),
            clientSUCURSAL: atob(this.clientSucursal)
        };
    },
    beforeUnmount() {
        window.removeEventListener("beforeunload", beforeUnloadHandler);
        // this.stopScanner();
    },
    mounted() {
        //  console.log(atob(this.clientId))
        //  console.log(atob(this.sucursalId))
        // console.log(typeof (this.sucursalID))
        //  console.log(atob(this.clientName))
        // console.log(atob(this.clientSucursal))
        this.$swal.fire({
            title: 'Cargando...',
            allowOutsideClick: false,
            allowEscapeKey: false,
            didOpen: () => {
                this.$swal.showLoading();
            }
        });
        window.addEventListener("beforeunload", beforeUnloadHandler);
        let urls = [
            `/api/getstocks`,
            `/api/getclientproducts/${this.clientID}`
        ]

        if (this.sucursalID !== '0') {
            urls = [
                `/api/getstocks`,
                `/api/getclientproducts/${this.clientID}/${this.sucursalID}`
            ]
        }

        let requests = urls.map(url => this.plain.get(url))
        axios.all(requests).then(axios.spread((stockResponse, productosResponse) => {
            if (stockResponse.data.message === "Consulta exitosa" && productosResponse.data.message === "Consulta exitosa") {
                stockResponse.data.productos.forEach((producto) => {
                    producto.precio_publico = parseFloat(producto.precio_publico.replace(/,/g, ''));
                    this.stocks.set(producto.sku, producto)
                    //POR BORRAR
                    // if (index < 11)//*
                    //     console.log(producto.precio_publico)//*
                    //LINEAs DE PRUEBA PARA LLENAR PRODUCTOS DEBE BORRARSE
                    // let productoAUX = { ...producto }//*
                    // delete productoAUX.precio_publico//*
                    // delete productoAUX.existencia//*
                    // productoAUX.existencia_sugerida = Math.floor(Math.random() * 5) + 1//*
                    // this.productos.set(producto.sku, productoAUX)//*
                });
                //LINEA ORIGINAL
                productosResponse.data.productos.forEach(producto => this.productos.set(producto.sku, producto))

                this.isLoading = false
                this.$swal.close()
            }
        })).catch((err) => {
            console.log(err)
            this.errURL = true
            this.$swal.close()
            this.$swal.fire({
                title: 'Datos del cliente no encontrados',
                text: 'Por favor selecciona un cliente valido.',
                icon: 'question',
                confirmButtonText: 'Aceptar',
                customClass: {
                    confirmButton: 'btn btn-warning btn-block m-3 bg-primary'
                },
                buttonsStyling: false,  // Desactivar el estilo predeterminado
            }).then(() => {
                this.$router.replace('/clients');
            })
        })
    },
    methods: {
        buscarSKU() {
            // console.log('Código de barra detectado:', result.codeResult.code);
            if (this.querySKU.length !== 0) {
                this.buscaProducto(this.querySKU)
            }
        },
        buscaProducto(sku) {
            let productoSelect = this.productos.get(sku)
            let stockSelect = this.stocks.get(sku)

            // if (!this.cart.some(producto => producto.sku === sku)) {
            if (productoSelect !== undefined && stockSelect !== undefined)
                // caso = "PRODUCTO-ULTIMA-VEZ y CON-STOCK"
                this.productoVenta(productoSelect, stockSelect)
            // else
            //     if (productoSelect !== undefined && stockSelect === undefined)
            //         // caso = "PRODUCTO-ULTIMA-VEZ y SIN-STOCK"
            //         this.productoSinStock(productoSelect)
            else
                if (productoSelect === undefined && stockSelect !== undefined)
                    // caso = "PRODUCTO-SIN-ULTIMA-VEZ y CON-STOCK"
                    this.productoVentaSinUltimaCompra(stockSelect)
                else
                    if (productoSelect === undefined && stockSelect === undefined)
                        // caso = "PRODUCTO-SIN-ULTIMA-VEZ y SIN-STOCK"
                        this.productoNoEncontrado(sku)
            // } 
            // else {
            //     this.$swal.fire({
            //         title: `Este producto ya se encuentra en la lista ${sku}`,
            //         confirmButtonText: "Aceptar",
            //         customClass: {
            //             confirmButton: 'btn btn-warning btn-block m-3 bg-primary'
            //         },
            //         buttonsStyling: false,  // Desactivar el estilo predeterminado
            //     })
            // }



        },
        productoVenta(productoSelect, stockSelect) {
            this.$swal.fire({
                title: `<strong>${stockSelect.nombre}</u></strong>`,
                icon: "info",
                html: `
                        <div class="card card-profile">
                            <div class="card-body pt-0">
                                <div class="text-center mt-4">
                                    <h5>
                                    ${stockSelect.sku ? stockSelect.sku : ""}
                                    </h5>
                                    <div class="h6 font-weight-300">
                                        <i class="ni location_pin mr-2"></i>${stockSelect.color ? stockSelect.color : ''}
                                    </div>
                                    <div class="h6 mt-4">
                                        <i class="ni business_briefcase-24 mr-2"></i>${stockSelect.talla ? stockSelect.talla : ''}
                                    </div>
                                </div> 
                                <h6>
                                    Inventario actual:
                                </h6>
                                <input
                                    type="number"
                                    value="${this.inventario}"
                                    class="swal2-input"
                                    id="range-value"
                                    min="0"
                                > 
                            </div>
                                         
                        </div>
                        `,
                showCloseButton: true,
                showCancelButton: true,
                confirmButtonText: "Agregar producto",
                cancelButtonText: "Cancelar",
                focusConfirm: false,
                customClass: {
                    confirmButton: 'btn btn-warning btn-block m-3 bg-primary',
                    cancelButton: 'btn btn-warning btn-block m-3 bg-secondary'
                },
                buttonsStyling: false,  // Desactivar el estilo predeterminado
                didOpen: () => {
                    const inputNumber = this.$swal.getPopup().querySelector('#range-value')
                    inputNumber.addEventListener('change', () => {
                        if (inputNumber.value >= 0)
                            this.inventario = inputNumber.value
                        else
                            this.inventario = 0
                    })
                }
            }).then((result) => {
                if (result.isConfirmed) {
                    this.text = ''
                    this.querySKU = ''
                    const { sugerido, sugerido_absoluto } = this.calculaSugeridoInicial(productoSelect.existencia_sugerida, this.inventario, stockSelect.existencia)
                    this.cartPush(
                        {
                            color: stockSelect.color,
                            existencia: stockSelect.existencia,
                            id: stockSelect.id,
                            nombre: stockSelect.nombre,
                            precio_publico: stockSelect.precio_publico,
                            sku: stockSelect.sku,
                            talla: stockSelect.talla,
                            ultima_compra: productoSelect.existencia_sugerida,
                            inventario: this.inventario,
                            sugerido_absoluto,
                            cantidad_sugerida: sugerido,
                            total: stockSelect.precio_publico * sugerido
                        }
                    )
                    this.inventario = 0
                }
                this.$refs.barCodeScanner.startScanner();
            })
        },
        productoVentaSinUltimaCompra(stockSelect) {
            this.$swal.fire({
                title: `<strong>${stockSelect.nombre}</u></strong>`,
                icon: "info",
                html: `
                        <div class="card card-profile">
                            <div class="card-body pt-0">
                                <div class="text-center mt-4">
                                    <h5>
                                    ${stockSelect.sku ? stockSelect.sku : ""}
                                    </h5>
                                    <div class="h6 font-weight-300">
                                        <i class="ni location_pin mr-2"></i>${stockSelect.color ? stockSelect.color : ''}
                                    </div>
                                    <div class="h6 mt-4">
                                        <i class="ni business_briefcase-24 mr-2"></i>${stockSelect.talla ? stockSelect.talla : ''}
                                    </div>
                                </div> 
                                <h6>
                                    Inventario actual:
                                </h6>
                                <input
                                    type="number"
                                    value="${this.inventario}"
                                    class="swal2-input"
                                    id="range-value2"
                                    min="0"
                                > 
                            </div>
                                         
                        </div>
                        `,
                showCloseButton: true,
                showCancelButton: true,
                confirmButtonText: "Agregar producto",
                cancelButtonText: "Cancelar",
                focusConfirm: false,
                customClass: {
                    confirmButton: 'btn btn-warning btn-block m-3 bg-primary',
                    cancelButton: 'btn btn-warning btn-block m-3 bg-secondary'
                },
                buttonsStyling: false,  // Desactivar el estilo predeterminado
                didOpen: () => {
                    const inputNumber = this.$swal.getPopup().querySelector('#range-value2')
                    inputNumber.addEventListener('change', () => {
                        if (inputNumber.value >= 0)
                            this.inventario = inputNumber.value
                        else
                            this.inventario = 0
                    })
                }
            }).then((result) => {
                if (result.isConfirmed) {
                    this.text = ''
                    this.querySKU = ''
                    const { sugerido, sugerido_absoluto } = this.calculaSugeridoInicial(0, this.inventario, stockSelect.existencia)
                    this.cartPush(
                        {
                            color: stockSelect.color,
                            existencia: stockSelect.existencia,
                            id: stockSelect.id,
                            nombre: stockSelect.nombre,
                            precio_publico: stockSelect.precio_publico,
                            sku: stockSelect.sku,
                            talla: stockSelect.talla,
                            ultima_compra: 0,
                            inventario: this.inventario,
                            sugerido_absoluto,
                            cantidad_sugerida: sugerido,
                            total: stockSelect.precio_publico * sugerido
                        }
                    )
                    this.inventario = 0
                }
                this.$refs.barCodeScanner.startScanner();
            })
        },
        productoNoEncontrado(sku) {
            this.text = ''
            this.querySKU = ''
            this.inventario = 0
            this.$swal.fire({
                title: "Producto no encontrado!!!",
                text: sku,
                icon: "error",
                confirmButtonColor: "#3085d6",
                confirmButtonText: "Aceptar",
                customClass: {
                    confirmButton: 'btn btn-warning btn-block m-3 bg-primary'
                },
                buttonsStyling: false,  // Desactivar el estilo predeterminado
            }).then(() => {
                // this.startScannerQ()
                this.$refs.barCodeScanner.startScanner();
            })
        },
        handleInputChange(event) {
            this.inventario = parseInt(event.target.value) // Asegúrate de que el valor sea un entero
        },
        handleInputChangePreOrden(producto, event) {
            // Aquí puedes ejecutar cualquier otra lógica que necesites cuando el valor cambie
            if (event.target.value > 0) {
                if (event.target.value <= producto.existencia)
                    producto.cantidad_sugerida = parseInt(event.target.value) // Asegúrate de que el valor sea un entero
                else
                    producto.cantidad_sugerida = producto.existencia
            }
            else
                producto.cantidad_sugerida = 1

            this.totalProducto(producto)
        },
        incrementPreOrden(producto) {
            producto.cantidad_sugerida++

            if (producto.cantidad_sugerida > producto.existencia)
                producto.cantidad_sugerida = producto.existencia // Asegúrate de que el valor sea un entero

            this.totalProducto(producto)
        },
        decrementPreOrden(producto) {
            producto.cantidad_sugerida--;

            if (producto.cantidad_sugerida <= 0)
                producto.cantidad_sugerida = 1

            this.totalProducto(producto)
        },
        calculaSugeridoInicial(ultima_compra, inventario, existencia) {
            if (ultima_compra > 0) {//PRODUCTO CON ULTIMA COMPRA
                if (inventario > 0) {
                    if (inventario < ultima_compra)
                        return { sugerido: existencia >= (ultima_compra - inventario) ? ultima_compra - inventario : existencia, sugerido_absoluto: ultima_compra - inventario }
                    else
                        return { sugerido: existencia > 0 ? 1 : 0, sugerido_absoluto: 0 }
                }
                else
                    return { sugerido: existencia >= ultima_compra ? ultima_compra : existencia, sugerido_absoluto: ultima_compra }
            }
            else//PRODUCTO SIN ULTIMA COMPRA
                if (inventario > 0)
                    return { sugerido: existencia > 0 ? 1 : 0, sugerido_absoluto: 0 }
                else
                    return {
                        sugerido: existencia > 1 ?
                            2
                            :
                            existencia >= 1 ?
                                1
                                :
                                0,
                        sugerido_absoluto: 2
                    }
        },
        totalProducto(producto) {
            producto.total = producto.cantidad_sugerida * producto.precio_publico
            this.calculaTotalPreOrden()

        },
        calculaTotalPreOrden() {
            this.totalPreOrden = 0;
            this.cart.forEach(producto => this.totalPreOrden += producto.total)
        },
        cartPush(newProducto) {
            if (!this.cart.some(producto => producto.id === newProducto.id)) {
                this.cart.unshift(newProducto)
                this.$swal.fire({
                    title: "Producto agregado!",
                    confirmButtonText: "Aceptar",
                    customClass: {
                        confirmButton: 'btn btn-warning btn-block m-3 bg-primary'
                    },
                    buttonsStyling: false,  // Desactivar el estilo predeterminado
                })
                this.calculaTotalPreOrden()
            } else {
                this.$swal.fire({
                    title: `Este producto ya se encuentra en la lista ${newProducto.nombre}`,
                    confirmButtonText: "Aceptar",
                    customClass: {
                        confirmButton: 'btn btn-warning btn-block m-3 bg-primary'
                    },
                    buttonsStyling: false,  // Desactivar el estilo predeterminado
                })
            }
        },
        eliminarProducto(index, producto) {
            this.$swal.fire({
                title: "Deseas eliminar este producto de la orden?",
                text: producto.nombre,
                icon: "warning",
                showCancelButton: true,
                confirmButtonText: "Si, eliminar!",
                cancelButtonText: "Cancelar",
                customClass: {
                    confirmButton: 'btn btn-warning btn-block m-3 bg-primary',
                    cancelButton: 'btn btn-warning btn-block m-3 bg-secondary'
                },
                buttonsStyling: false,  // Desactivar el estilo predeterminado
            }).then((result) => {
                if (result.isConfirmed) {
                    this.cart.splice(index, 1)
                    this.calculaTotalPreOrden()
                    this.$swal.fire({
                        title: "Eliminado!",
                        text: producto.nombre,
                        confirmButtonText: "Aceptar",
                        icon: "success",
                        customClass: {
                            confirmButton: 'btn btn-warning btn-block m-3 bg-primary'
                        },
                        buttonsStyling: false,  // Desactivar el estilo predeterminado
                    })
                }
            });
        },
        crearPreOrden() {
            let preOrden = []
            let inventario = []
            let inventarioAPI = []
            const hoy = new Date();

            this.$swal.fire({
                title: 'Enviando preorden...',
                allowOutsideClick: false,
                allowEscapeKey: false,
                didOpen: () => {
                    this.$swal.showLoading();
                }
            });

            const año = hoy.getFullYear();
            const mes = (hoy.getMonth() + 1).toString().padStart(2, '0'); // El mes es devuelto de 0 a 11, por eso se suma 1
            const dia = hoy.getDate().toString().padStart(2, '0');

            this.cart.forEach(producto => {
                preOrden.push({ id: producto.id, cantidad: producto.cantidad_sugerida })
                inventario.push({ id: producto.id, sku: producto.sku, nombre: producto.nombre, ultima_compra: producto.ultima_compra, inventario: producto.inventario, sugerido: producto.sugerido_absoluto, preorden: producto.cantidad_sugerida })
                inventarioAPI.push({ id: producto.id, cantidad: parseInt(producto.inventario) })
            })

            this.plain
                .post(`/api/setpreorders`, { user_id: parseInt(this.clientID), sucursal_id: parseInt(this.sucursalID), productos: preOrden, })
                .then((response) => {
                    // console.log(response)
                    if (response.data.message === "Pedido sugerido creado con exito") {
                        this.endOperation = true;
                        this.$swal.close()
                        this.$swal.fire({
                            title: "Preorden creada correctamente!!!",
                            text: 'Ahora intentaremos guardar el inventario actual',
                            icon: "success",
                            confirmButtonText: "Aceptar",
                            customClass: {
                                confirmButton: 'btn btn-warning btn-block m-3 bg-primary'
                            },
                            buttonsStyling: false,  // Desactivar el estilo predeterminado
                        }).then(() => {
                            const worksheet = utils.json_to_sheet(inventario);

                            const workbook = utils.book_new();

                            utils.book_append_sheet(workbook, worksheet, "Inventario");

                            /* fix headers */
                            utils.sheet_add_aoa(worksheet, [["ID", "SKU", "NOMBRE", "ULTIMA", "INVENTARIO", "SUGERIDO", "PREORDEN"]], { origin: "A1" });

                            /* calculate column width */
                            // const max_width = inventario.reduce((w, r) => Math.max(w, r.nombre.length), 10);
                            // worksheet["!cols"] = [{ wch: max_width }];

                            /* create an XLSX file and try to save to File.xlsx */
                            writeFileXLSX(workbook, `${this.clientNAME}_${this.clientID}${this.sucursalID !== '0' ? `-${this.clientSUCURSAL.length > 0 ? `${this.clientSUCURSAL}_${this.sucursalID}` : this.sucursalID}-` : "-"}${dia}_${mes}_${año}.xlsx`, { compression: true });

                            this.guardarInventario(inventarioAPI, `${año}-${mes}-${dia}`)
                        })
                    }
                    else {
                        this.$swal.close()
                        this.$swal.fire({
                            icon: "error",
                            title: "La preorden no pudo ser guardada correctamente.",
                            text: "Por favor intentalo nuevamente"
                        });
                    }
                })
                .catch((error) => {
                    console.log(`Error /api/setpreorders/${this.clientID}`, error);
                    this.$swal.close()
                    this.$swal.fire({
                        icon: "error",
                        title: "La preorden no pudo ser guardada correctamente.",
                        text: "Por favor intentalo nuevamente"
                    });
                })
        },
        guardarInventario(inventario, fecha) {
            this.$swal.fire({
                title: 'Enviando inventario...',
                allowOutsideClick: false,
                allowEscapeKey: false,
                didOpen: () => {
                    this.$swal.showLoading();
                }
            })

            this.plainAuth
                .post(`/api/inventory`, { cliente_id: parseInt(this.clientID), sucursal_id: parseInt(this.sucursalID), fecha, productos: inventario })
                .then((response) => {
                    if (response.data.message === "Inventario creado con exito") {
                        this.$swal.close()
                        this.$swal.fire({
                            title: "Inventario guardado correctamente!!!",
                            text: 'Regresaras a la lista de clientes',
                            icon: "success",
                            confirmButtonText: "Aceptar",
                            customClass: {
                                confirmButton: 'btn btn-warning btn-block m-3 bg-primary'
                            },
                            buttonsStyling: false,  // Desactivar el estilo predeterminado
                        }).then(() => {
                            this.$router.replace('/clients')
                        })
                    }
                    else {
                        this.$swal.close()
                        this.$swal.fire({
                            icon: "error",
                            title: "El inventario no pudo ser guardado correctamente.",
                            text: "Por favor intentalo nuevamente",
                            showCancelButton: true,
                            confirmButtonText: "Intentar nuevamente",
                            confirmButtonColor: 'bg-primary',
                            cancelButtonText: "Continuar sin guardar",
                            focusConfirm: false,
                            customClass: {
                                confirmButton: 'btn btn-warning btn-block m-3 bg-primary',
                                cancelButton: 'btn btn-warning btn-block m-3 bg-secondary'
                            },
                            buttonsStyling: false,  // Desactivar el estilo predeterminado
                        }).then((result) => {
                            if (result.isConfirmed)
                                this.guardarInventario(inventario, fecha)
                            else
                                this.$router.replace('/clients')
                        }
                        )
                    }
                })
                .catch((error) => {
                    console.log(`Error /api/inventory`, error);
                    this.$swal.close()
                    this.$swal.fire({
                        icon: "error",
                        title: "El inventario no pudo ser guardado correctamente.",
                        text: "Por favor intentalo nuevamente",
                        showCancelButton: true,
                        confirmButtonText: "Intentar nuevamente",
                        confirmButtonColor: 'bg-primary',
                        cancelButtonText: "Continuar sin guardar",
                        focusConfirm: false,
                        customClass: {
                            confirmButton: 'btn btn-warning btn-block m-3 bg-primary',
                            cancelButton: 'btn btn-warning btn-block m-3 bg-secondary'
                        },
                        buttonsStyling: false,  // Desactivar el estilo predeterminado
                    }).then((result) => {
                        if (result.isConfirmed)
                            this.guardarInventario(inventario, fecha)
                        else
                            this.$router.replace('/clients')
                    }
                    )
                })
        }
    },
    beforeRouteLeave(to, from, next) {
        if (!this.errURL && !this.endOperation) {
            Swal.fire({
                title: '¿Estás seguro?',
                text: '¿Quieres abandonar esta página?',
                icon: 'question',
                showCancelButton: true,
                confirmButtonText: 'Sí',
                cancelButtonText: 'Cancelar',
                customClass: {
                    confirmButton: 'btn btn-warning btn-block m-3 bg-primary',
                    cancelButton: 'btn btn-warning btn-block m-3 bg-secondary'
                },
                buttonsStyling: false,  // Desactivar el estilo predeterminado
            }).then((result) => {
                // Llamamos a next() solo después de que el usuario interactúe con la alerta
                if (result.isConfirmed) {
                    next();
                } else {
                    // Si el usuario cancela, no cambiamos de ruta
                    next(false);
                }
            })
        }
        else
            next()
    }
};
</script>
<style>
.text-danger:hover {
    cursor: pointer;
}
</style>